__turbopack_context__.v({
  "caption": "checkout-flow-module-scss-module__Mza1Ja__caption",
  "collapsed": "checkout-flow-module-scss-module__Mza1Ja__collapsed",
  "collapsed-head": "checkout-flow-module-scss-module__Mza1Ja__collapsed-head",
  "head": "checkout-flow-module-scss-module__Mza1Ja__head",
  "heading": "checkout-flow-module-scss-module__Mza1Ja__heading",
  "layout": "checkout-flow-module-scss-module__Mza1Ja__layout",
  "note": "checkout-flow-module-scss-module__Mza1Ja__note",
  "number": "checkout-flow-module-scss-module__Mza1Ja__number",
  "progress": "checkout-flow-module-scss-module__Mza1Ja__progress",
  "progress-native": "checkout-flow-module-scss-module__Mza1Ja__progress-native",
  "row": "checkout-flow-module-scss-module__Mza1Ja__row",
  "segment": "checkout-flow-module-scss-module__Mza1Ja__segment",
  "step": "checkout-flow-module-scss-module__Mza1Ja__step",
  "step-body": "checkout-flow-module-scss-module__Mza1Ja__step-body",
  "step-title": "checkout-flow-module-scss-module__Mza1Ja__step-title",
  "steps": "checkout-flow-module-scss-module__Mza1Ja__steps",
  "sum": "checkout-flow-module-scss-module__Mza1Ja__sum",
  "summary": "checkout-flow-module-scss-module__Mza1Ja__summary",
  "summary-body": "checkout-flow-module-scss-module__Mza1Ja__summary-body",
  "summary-count": "checkout-flow-module-scss-module__Mza1Ja__summary-count",
  "summary-line": "checkout-flow-module-scss-module__Mza1Ja__summary-line",
  "summary-toggle": "checkout-flow-module-scss-module__Mza1Ja__summary-toggle",
  "summary-toggle-total": "checkout-flow-module-scss-module__Mza1Ja__summary-toggle-total",
  "sums": "checkout-flow-module-scss-module__Mza1Ja__sums",
  "thumb": "checkout-flow-module-scss-module__Mza1Ja__thumb",
  "thumbs": "checkout-flow-module-scss-module__Mza1Ja__thumbs",
  "title": "checkout-flow-module-scss-module__Mza1Ja__title",
  "total": "checkout-flow-module-scss-module__Mza1Ja__total",
  "total-label": "checkout-flow-module-scss-module__Mza1Ja__total-label",
  "total-value": "checkout-flow-module-scss-module__Mza1Ja__total-value",
});
